  import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
  import {Observable} from "rxjs";
  import {BuildKit} from "../models/build-kit.model";

@Injectable({
  providedIn: 'root'
})
export class TenantRoleService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}


  getRoleAndTenantData(tenantId: string, roleId: string): Observable<any> {
    return this.http.get<any[]>(this.brennerSoftwareApiEndpoint + `tenantRole/`);
  }
}
